

export default[
    {
        img:"car.jpg",
        name:"Car Loan",
        des:"Need a new car? Learn about car buying experience, loan and insurance",
        link:"https://handsonbanking.org/topics/cars/"
    },
    {
        img:"school.png",
        name:"After Schooling",
        des:"Explore school and career option after completing school, and financial consideration for both",
        link:"https://handsonbanking.org/topics/after-high-school/"
    },
    {
        img:"banking.png",
        name:"Banking",
        des:"Want to know about banking? Learn the (what, why, and how) of using a financial institution.",
        link:"https://handsonbanking.org/topics/banking/"
    },
    {
        img:"loan.jpg",
        name:"Credit and Loans",
        des:"What is credit, and why does it matter? How do loans and credit cards work?Get answer here.",
        link:"https://handsonbanking.org/topics/credit-and-loans/"
    },
    {
        img:"goal.jpg",
        name:"Goal Setting",
        des:"Define your needs and wants, then plan how you'll get there. Explore financial planning, insurance, and more",
        link:"https://handsonbanking.org/topics/goal-setting/"
    },
    {
        img:"investing.png",
        name:"Investing",
        des:"You can build wealth through savings, investments, property, or your own business. These resources give you and your family options and opportunities",
        link:"https://handsonbanking.org/topics/investing/"
    },
    {
        img:"manage.jpg",
        name:"Money Management",
        des:"Budgeting, spending, saving: Get practical tips for managing money day-to-day and preparing for the unexpected",
        link:"https://handsonbanking.org/topics/money-management/"
    },
    {
        img:"retirement.jpg",
        name:"Retirement",
        des:"Learn how to support yourself after you finish your career. Planning early is key.",
        link:"https://handsonbanking.org/topics/retirement/"
    },
    {
        img: "insurance.jpg",
        name: "Insurance Planning",
        des: "Protect yourself and your family. Understand different types of insurance and how they can provide financial security.",
        link: "https://handsonbanking.org/topics/insurance-planning/"
    },
    {
        img: "debt.jpg",
        name: "Debt Management",
        des: "Struggling with debt? Learn strategies for managing and reducing debt, and find out how to stay out of debt.",
        link: "https://handsonbanking.org/topics/debt-management/"
    },
]